import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { catchError, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Result } from "../models/common/result";
import { VehicleCashout } from "./../models/vehicles/vehicle-cashout";
import { LogService } from "./log.service";
import { MessagesService } from "./messages.service";

@Injectable()
export class VehicleCashoutService {
  private origin: string = environment.API_BASE_URL;

  constructor(
    private _http: HttpClient,
    private _logService: LogService,
    private _messagesService: MessagesService
  ) {}

  getVehicleCashout(id: number): Observable<Result<VehicleCashout>> {
    return this._http
      .get<Result<VehicleCashout>>(`${this.origin}/api/vehicle-cashouts/${id}`)
      .pipe(
        tap((x) => this.log(`getVehicleCashout: id=${id}`)),
        catchError(
          this._logService.handleError<Result<VehicleCashout>>(
            "getVehicleCashout"
          )
        )
      );
  }

  addVehicleCashout(
    vehicleCashout: VehicleCashout
  ): Observable<Result<number>> {
    return this._http
      .post<Result<number>>(
        `${this.origin}/api/vehicle-cashouts`,
        JSON.stringify(vehicleCashout)
      )
      .pipe(
        tap((x) =>
          this.log(`addVehicleCashout: vehicleId=${vehicleCashout.vehicleId}`)
        ),
        catchError(
          this._logService.handleError<Result<number>>("addVehicleCashout")
        )
      );
  }

  updateVehicleCashout(
    vehicleCashout: VehicleCashout
  ): Observable<Result<null>> {
    return this._http
      .put<Result<null>>(
        `${this.origin}/api/vehicle-cashouts/${vehicleCashout.id}`,
        JSON.stringify(vehicleCashout)
      )
      .pipe(
        tap((x) => this.log(`updateVehicleCashout: id=${vehicleCashout.id}`)),
        catchError(
          this._logService.handleError<Result<null>>("updateVehicleCashout")
        )
      );
  }

  deleteVehicleCashout(
    id: number
  ): Observable<Result<null>> {
    return this._http
      .delete<Result<null>>(
        `${this.origin}/api/vehicle-cashouts/${id}`
      )
      .pipe(
        tap((x) => this.log(`deleteVehicleCashout: id=${id}`)),
        catchError(
          this._logService.handleError<Result<null>>("deleteVehicleCashout")
        )
      );
  }

  private log(message: string) {
    this._messagesService.add("VehicleCashoutService: " + message);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/vehicle-cashout.service.ts